// Shown when /app (the Teams tab) is opened in a plain browser tab. There is
// no Teams host to sign in with, so offer the two things that do work: the
// Teams deep link, or the same app in the browser with a Microsoft sign-in.

import { ExternalLink, Globe, Phone } from 'lucide-react';
import { teamsTabLink } from '../lib/teamsLinks';
import { buildAppPath, parseAppParams } from '../lib/webRoutes';

export function NotInTeamsCard() {
  const params = parseAppParams(window.location.search);
  const teamsUrl = teamsTabLink(params.initialUserTab === 'callflows' ? 'quickdial-phonemenu' : 'quickdial-user');
  const webUrl = buildAppPath(undefined, params);
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg border border-gray-200 p-6 text-center">
        <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center mx-auto mb-3">
          <Phone className="w-6 h-6 text-purple-600" />
        </div>
        <h1 className="text-lg font-semibold text-gray-900 mb-1">Quick Dial opens inside Microsoft Teams</h1>
        <p className="text-sm text-gray-600 mb-5">This link is the Teams tab. Open it in Teams, or continue here in the browser with your Microsoft sign-in.</p>
        <div className="flex flex-col sm:flex-row gap-2 justify-center">
          <a href={teamsUrl} className="inline-flex items-center justify-center gap-1.5 px-4 py-2 text-sm bg-purple-600 hover:bg-purple-700 text-white rounded font-medium">
            <ExternalLink className="w-4 h-4" />Open in Teams
          </a>
          <a href={webUrl} className="inline-flex items-center justify-center gap-1.5 px-4 py-2 text-sm border border-gray-300 rounded hover:bg-gray-50 text-gray-700 font-medium">
            <Globe className="w-4 h-4" />Continue in the browser
          </a>
        </div>
      </div>
    </div>
  );
}
